import { AppliedPromoDetail } from '@/components/CheckoutSubscriptionPlan'
import { trpc } from '@/utils/trpc'
import { useMemo } from 'react'

export function useUpgradeEstimate(
  userHasPlan: boolean,
  selectedPlan: { no_trial_plan_id: string },
  appliedPromo: AppliedPromoDetail | undefined,
  couponId?: string,
) {
  const coupon = useMemo(() => {
    return couponId && appliedPromo ? ([couponId].filter(Boolean) as string[]) : undefined
  }, [couponId, appliedPromo])

  const { data: upgradeEstimate, refetch: refetchUpgradeEstimate } = trpc.getSubscriptionUpdateEstimate.useQuery(
    {
      plans: [selectedPlan.no_trial_plan_id],
      coupons: coupon,
    },
    {
      enabled: userHasPlan,
    },
  )

  return { upgradeEstimate, refetchUpgradeEstimate }
}
